var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopicContent = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@wheelroom/core");

var topic_content_actions_1 = require("./topic-content-actions");

var topic_content_text_1 = require("./topic-content-text");

exports.TopicContent = function (props) {
  if (props.data.hideContent) {
    return null;
  }

  var topicInfo = props.topicInfo;
  var topicOptions = props.topicOptions;
  var showAction = topicInfo.hasAction && !topicOptions.hideAction && !props.data.hideActions;
  var isEmpty = (!topicInfo.hasIcon || topicOptions.hideIcon) && (!topicInfo.hasHeading || topicOptions.hideHeading) && (!topicInfo.hasAbstract || topicOptions.hideAbstract) && (!topicInfo.hasAction || topicOptions.hideAction);

  if (isEmpty) {
    return null;
  }

  return react_1.default.createElement(core_1.Box, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.content
    })
  }, react_1.default.createElement(topic_content_text_1.TopicContentText, {
    data: props.data,
    topic: props.topic,
    topicInfo: topicInfo,
    topicOptions: props.topicOptions,
    useIconElement: props.useIconElement,
    useAbstractElement: props.useAbstractElement,
    useAbstractParser: props.useAbstractParser,
    useHeadingElement: props.useHeadingElement,
    useHeadingParser: props.useHeadingParser,
    wheel: props.wheel
  }), showAction && react_1.default.createElement(topic_content_actions_1.TopicContentActions, {
    fullTopicAsLink: props.fullTopicAsLink,
    maxActions: props.maxActions,
    topic: props.topic,
    topicInfo: topicInfo,
    topicOptions: props.topicOptions,
    wheel: props.wheel
  }));
};